import { defineComponent as _defineComponent } from 'vue'
import Input from '@/components/ui/input/Input.vue'
import Dropdown from '@/components/ui/dropdown/Dropdown.vue'
import Button from '@/components/ui/button/Button.vue'
import { computed, inject, watch } from 'vue'
import { AlertSettingsViewModel } from '../viewmodels/AlertSettings.viewmodel'
import HelpTooltip from '@/@web/ui/components/HelpTooltip.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AlertSettingsForm',
  setup(__props) {

const vm = inject<AlertSettingsViewModel>('alert-settings-view-model') as AlertSettingsViewModel

const title = computed(() =>
	vm.alertSettings.value.id
		? 'Editar Configurações de Alerta'
		: 'Cadastrar Configurações de Alerta',
)

watch(vm.openForm, (value) => {
	if (value) vm.getMonitoredAreas()
})

return { __sfc: true,vm, title, Input, Dropdown, Button, HelpTooltip }
}

})